module.exports = __webpack_public_path__ + "img/payid.1237e496.svg";